import type {Ix3Type} from '../types';

export function getIx3FromComponentScope(
  ix3: Ix3Type,
  componentId: string
): Ix3Type {
  const interactions = ix3.interactions.filter(
    (interaction) =>
      interaction.scope?.type === 'component' &&
      interaction.scope.componentId === componentId
  );

  const timelineIds = new Set<string>();
  interactions.forEach((interaction) => {
    interaction.timelineIds?.forEach((id: string) => timelineIds.add(id));
  });

  const timelines = ix3.timelines.filter((timeline) =>
    timelineIds.has(timeline.id)
  );

  return {interactions, timelines};
}

/**
 * Normalizes ix3 data to undefined when it has no interactions or timelines.
 * Dependency producers must omit empty ix3 (rather than include
 * `{interactions: [], timelines: []}`) so that key presence — which affects
 * the hashed component dependencies — stays consistent across producers.
 */
export function toNonEmptyIx3(
  ix3: Partial<Ix3Type> | undefined
): Ix3Type | undefined {
  const interactions = ix3?.interactions ?? [];
  const timelines = ix3?.timelines ?? [];
  return interactions.length > 0 || timelines.length > 0
    ? {interactions, timelines}
    : undefined;
}
